import { useSetQuantity } from "@Modules/eventPage/utils/merchandise";
import { useEventDataOfSelectedEvent } from "@Utils/event";
import { ACTION_TYPES, createAction } from "@Utils/constants/actions";
import { useDispatch } from "react-redux";
import { checkIsObjectEmpty } from "repoV2/utils/common/dataTypes/object";
import { IHelperComponents } from "../components/IHelperComponents";
import { getVariantCombinationString, getVariantOptions } from "./utils";
import { useHideVariantSelector } from "./useHideVariantSelector";

const HURRY_MESSAGE_THRESHOLD = 10;

const useVariantSelector = () => {
    const dispatch = useDispatch();
    const setQuantity = useSetQuantity();

    const hideComponent = useHideVariantSelector();

    const { eventData } = useEventDataOfSelectedEvent();
    const {
        variantsData,
        uuid,
        selectedVariantCombination = {},
        selectedVariant,
    } = eventData;
    const {
        variants_display_data = {},
        variants = {},
        variant_type_order: variantTypeOrder,
    } = variantsData || {};
    const variantOptions = getVariantOptions(variants_display_data);

    const { purchased_inventory = 0, total_inventory = 0 } =
        selectedVariant || {};
    const remainingQuantity = total_inventory - purchased_inventory;
    const isOutOfStock =
        selectedVariant &&
        !selectedVariant.allow_overflow &&
        remainingQuantity < 1;
    const showHurryUp =
        selectedVariant &&
        !selectedVariant.allow_overflow &&
        remainingQuantity &&
        remainingQuantity < HURRY_MESSAGE_THRESHOLD;

    // hadTotal Payable Amount
    const itemNotAvailable =
        Object.keys(selectedVariantCombination).length ===
            Object.keys(variants_display_data).length &&
        checkIsObjectEmpty(selectedVariant);

    const handleClick = (
        e: React.SyntheticEvent,
        variantOption: IHelperComponents.IVariantOption
    ) => {
        // generating new combination object - start
        const { type, option } = variantOption;
        const newSelectedVariantCombination = { ...selectedVariantCombination };
        newSelectedVariantCombination[type] = option;
        dispatch(
            createAction(ACTION_TYPES.EVENT.UPDATE_EVENT_LISTING_DATA, {
                payload: {
                    eventId: uuid,
                    data: newSelectedVariantCombination,
                    source: "selectedVariantCombination",
                },
            })
        );
        // generating new combination object - end

        // getting variant from selected variant combination - start
        const variantKey = getVariantCombinationString(
            newSelectedVariantCombination,
            variantTypeOrder
        );
        const newSelectedVariant = variants[variantKey!];

        if (newSelectedVariant) setQuantity(1);

        dispatch(
            createAction(ACTION_TYPES.EVENT.UPDATE_EVENT_LISTING_DATA, {
                payload: {
                    eventId: uuid,
                    data: newSelectedVariant,
                    source: "selectedVariant",
                },
            })
        );
        // getting variant from selected variant combination - end
    };

    const isSelected = (inputOption: IHelperComponents.IVariantOption) =>
        selectedVariantCombination[inputOption.type] === inputOption.option;

    return {
        hideComponent,
        variantOptions,
        handleClick,
        isSelected,
        itemNotAvailable,
        isOutOfStock,
        showHurryUp,
    };
};

export default useVariantSelector;
